function increment(id) {
  var input = document.getElementById(id);
  var currentValue = parseInt(input.value);
  input.value = currentValue + 1;

  // Create a new event
  var event = new Event("change", {
    bubbles: true, // Allows the event to bubble up through the DOM
    cancelable: true, // Allows the event to be canceled
  });

  // Dispatch the event
  input.dispatchEvent(event);
  if (id == "product_qty_sticky") {
    document.querySelector("#qtybuy_button").value = input.value;
  }
}
function decrement(id) {
  var input = document.getElementById(id);
  var currentValue = parseInt(input.value);

  if (currentValue > 1) {
    input.value = currentValue - 1;
  }

  // Create a new event
  var event = new Event("change", {
    bubbles: true, // Allows the event to bubble up through the DOM
    cancelable: true, // Allows the event to be canceled
  });

  // Dispatch the event
  input.dispatchEvent(event);
  if (id == "product_qty_sticky") {
    document.querySelector("#qtybuy_button").value = input.value;
  }
}
